import {
    logUserDataResponseError,
    processCategoryMutateResponse,
    processItemMutateResponse,
} from './processResponse';
import { format } from 'owa-localize';
import { makePatchRequest } from 'owa-ows-gateway';
import {
    EditUserDataItemRequest,
    UserDataItem,
    UserDataItemResponse,
    UserDataResponseStatus,
} from '../data/schema/UserDataStoreSchema';

const EDIT_USER_DATA_ITEM_URL: string = 'ows/v1.5/UserDataStore/item';
const EDIT_USER_DATA_CATEGORY_URL = 'ows/v1.5/category/{0}/name/{1}';
const UPDATE_CATEGORY_ACTION_NAME = 'UpdateUserDataCategory';
const EDIT_USER_DATA_ITEM_ACTION_NAME = 'EditUserDataItem';

/**
 * Edit the category of a UserDataStore Item.
 * @param id: The original category id to update.
 * @param newCategoryName: The new category name.
 */
export async function editUserDataCategoryService(
    id: string,
    newCategoryName: string
): Promise<UserDataItemResponse> {
    const apiUrl = format(EDIT_USER_DATA_CATEGORY_URL, id, newCategoryName);
    try {
        const response = await makePatchRequest(
            apiUrl,
            null /* requestObject */,
            null /* correlationId */,
            true /* returnFullResponse */
        );
        return processCategoryMutateResponse(response, UPDATE_CATEGORY_ACTION_NAME);
    } catch (error) {
        logUserDataResponseError(UPDATE_CATEGORY_ACTION_NAME, error?.message);
        return Promise.resolve(<UserDataItemResponse>{
            status: UserDataResponseStatus.UNEXPECTED_ERROR,
        });
    }
}

/**
 * Edit the specific UserDataItem.
 * @param newItem: The UserDataItem with new value to update.
 */
export async function editUserDataItemService(
    newItem: UserDataItem
): Promise<UserDataItemResponse> {
    const request: EditUserDataItemRequest = {
        id: newItem.id,
        key: newItem.key,
        value: newItem.value,
        isPinned: newItem.property.isPinned,
    };
    try {
        const response = await makePatchRequest(
            EDIT_USER_DATA_ITEM_URL,
            request,
            undefined /* correlationId */,
            true /* returnFullResponse */
        );
        return processItemMutateResponse(response, EDIT_USER_DATA_ITEM_ACTION_NAME);
    } catch (error) {
        logUserDataResponseError(EDIT_USER_DATA_ITEM_ACTION_NAME, error?.message);
        return Promise.resolve(<UserDataItemResponse>{
            status: UserDataResponseStatus.UNEXPECTED_ERROR,
        });
    }
}
